import { useMemo } from 'react';
import { faSquare } from '@fortawesome/pro-solid-svg-icons';
import { Chip } from 'framework/chip';
import { CHIP_VARIANT } from 'framework/chip/enums';
import { useGridColumnContext } from 'framework/Grid/context/GridColumnContext';
import { useGridRowContext } from 'framework/Grid/context/GridRowContext';
import { getPairStatusVariant } from 'utils/variants';

import cn from './Cell.module.scss';

export const GridStatusChipCell = <T extends Record<string, any>>() => {
  const { row } = useGridRowContext<T>();
  const { column } = useGridColumnContext();
  const label = row.status_name || '';
  const variant = useMemo((): CHIP_VARIANT => getPairStatusVariant(row.status_id), [row]);
  return (
    <div className={cn.cell} style={{ justifyContent: column.text_align }}>
      <Chip
        label={label}
        icon={faSquare}
        variant={variant}
        width="100%"
        theme={{ chip: { border: { normal: 'transparent' } } }}
      />
    </div>
  );
};
